export enum InventoryLogType {
  INITIAL_STOCK = "INITIAL_STOCK",
  SALE = "SALE",
  PURCHASE_RECEIPT = "PURCHASE_RECEIPT",
  RETURN_CUSTOMER = "RETURN_CUSTOMER",
  RETURN_SUPPLIER = "RETURN_SUPPLIER",
  ADJUSTMENT_DAMAGE = "ADJUSTMENT_DAMAGE",
  ADJUSTMENT_COUNT = "ADJUSTMENT_COUNT",
}
